export default "__VITE_ASSET__BbjY6VPm__"